export let CalConfigs: CalConfigItem[] = [
  {
    name: 'DATE_TIME_FORMAT',
    value: 'DD/MM/YYYY HH:mm',
    description: 'Định dạng hiển thị ngày và thời gian'
  },
  {
    name: 'DATE_FORMAT',
    value: 'DD/MM/YYYY',
    description: 'Định dạng hiển thị ngày'
  },
  {
    name: 'TIME_FORMAT',
    value: 'HH:mm',
    description: 'Định dạng hiển thị thời gian'
  },
  {
    name: 'TIME_NEW_UPDATE',
    value: '12',
    description: 'Thời gian hiển thị lịch mới cập nhật: giờ'
  },
  {
    name: 'NOTE_LAST_UPDATE',
    value: true,
    description: 'Hiển thị thời gian sửa đổi cuối cùng: true | false'
  },
  {
    name: 'EVENT_BETWEEN_UNIT',
    value: true,
    description: 'Lịch giữa các đơn vị: true | false'
  },

  {
    name: 'PUBLISH_VIEW',
    value: 'date',
    description: '[Trang ban hành] Chế độ hiển thị mặc định: week | date'
  },

  {
    name: 'TV_VIEW',
    value: 'date',
    description: '[Trang tivi] Chế độ hiển thị: week | date'
  },
  {
    name: 'TV_TRANS_VELOCITY',
    value: '30',
    description: '[Trang tivi] Tốc độ chạy của lịch trên mỗi pixcel - millisecond'
  },


  {
    name: 'EMBED_VIEW',
    value: 'date',
    description: '[Trang nhúng] Chế độ hiển thị mặc định: week | date'
  },
  {
    name: 'EMBED_VIEW_PAST',
    value: true,
    description: '[Trang nhúng] Hiển thị những lịch đã diễn ra: true | false'
  },

  {
    name: 'PERSON_VIEW',
    value: 'listWeek',
    description: '[Trang lịch] Chế độ hiển thị mặc định: agendaWeek | agendaDay | listWeek'
  },
  {
    name: 'PERSON_CREATE_TYPE',
    value: 'COMMUNITY',
    description: '[Trang lịch] Loại lịch mặc định khi tạo: COMMUNITY (cộng đồng) | ORGANIZATION (nội bộ)'
  },

  {
    name: 'INVITATION_SUPPORT',
    value: true,
    description: 'Hỗ trợ thư mời hợp'
  },

  // Department
  {
    name: 'DEPARTMENT_VIEW_OTHER',
    value: true,
    description: 'Xem lịch của phòng ban khác: true'
  },
  {
    name: 'DEPARTMENT_APPROVE_OTHER',
    value: false,
    description: 'Duyệt lịch của phòng ban khác: false'
  },

  {
    name: 'CAR_TYPE_CREATE',
    value: 'COMMUNITY',
    description: 'Loại lịch mặc định khi tạo lịch xe: COMMUNITY | ORGANIZATION'
  },

  {
    name: 'CALENDAR_INCLUDE_CAR',
    value: 'false',
    description: 'Hiển thị lịch bao gồm lich xe'
  },

  {
    name: 'EDIT_EVENT_PAST',
    value: false,
    description: 'Cho phép cập nhật nội dung lịch đã diễn ra: false'
  },

  {
    name: 'PERSONAL_CAN_PUBLISH',
    value: false,
    description: '[Lịch cá nhân] Cho phép ban hành: false'
  },

  {
    name: 'PEOPLE_EVENT_ENABLE',
    value: false,
    description: 'Cho phép tạo lịch tiếp dân'
  },

  {
    name: 'PERSONAL_EVENT_ENABLE',
    value: false,
    description: 'Cho phép tạo lịch cá nhân'
  },
  {
    name: 'CAR_EVENT_ENABLE',
    value: false,
    description: 'Cho phép tạo lịch xe'
  },
  {
    name: 'ATTENDEE_DISPLAY_MAX_LENGTH',
    value: '0',
    description: 'Độ dài hiển thị tối đa của thành phần'
  },
  {
    name: 'VIEW_BY_LEADER',
    value: true,
    description: 'Xem lịch theo danh sách lãnh đạo'
  },
  {
    name: 'MOBILE_VIEW_BY_LEADER',
    value: false,
    description: '[Mobile] Mặc định xem lịch theo danh sách lãnh đạo'
  },
  {
    name: 'MOBILE_VIEW_BY_LEADER_ENABLE',
    value: false,
    description: '[Mobile] Xem lịch theo danh sách lãnh đạo'
  },
  {
    name: 'PUBLISH_EVENT_AFTER_CREATE',
    value: false,
    description: 'Ban hành lịch sau khi tạo'
  },
  {
    name: 'CHECK_DUPLICATE_BEFORE_PUBLISH',
    value: false,
    description: 'Kiểm tra lịch trùng trước khi ban hành'
  },
  {
    name: 'SUBJECT_DISPLAY_MAX_LENGTH',
    value: '0',
    description: 'Độ dài hiển thị tối đa của nội dung lịch'
  },
  {
    name: 'PREFIX_ATTENDEE_NAME',
    value: '',
    description: 'Tiền tố hiển thị trước tên người dùng khi tạo lịch'
  },
  {
    name: 'WORK_TIME_START',
    value: '7:00',
    description: 'Thời gian bắt đầu làm việc'
  },
  {
    name: 'WORK_TIME_END',
    value: '17:00',
    description: 'Thời gian kết thúc làm việc'
  },
  {
    name: 'NOTIFY_TO_ATTENDEE_ENABLE',
    value: 'false',
    description: 'Cho phép người duyệt lịch gửi thông báo nhắc nhở cho người nhận'
  },
];

export interface CalConfigItem {
  name: string
  value: any
  description?: string
}
